import store from "../store";
import { TextTranslationType } from "../types/textTranslationType";

export function getCurrentTextTranslation(languages?: Array<TextTranslationType>) {
  const lang = store.getState().persisted.appLanguage;
  return languages?.find((it) => it?.language?.langCode === lang)?.text || languages?.at(0)?.text || "";
}
